/* eslint-disable react/jsx-pascal-case */
import ContentState from "../../../Component/UI/ContentState";
import SearchSubmitButton from "../../../Component/UI/SearchSubmitButton";
import styled from "styled-components";
import Layout_user from "../../../Component/UI/Layout_user";
import { Link, useLocation } from "react-router-dom";
import { useCallback, useEffect, useRef, useState } from "react";
import TopBar from "../../../Component/UI/TopBar";
import Footer from "../../../Component/UI/Footer";
import api2 from "../../../Component/axios_Interceptor/api2";
import url, { SERVER_ADDRESS } from "../../../Component/server";
import api, { restoreSession } from "../../../Component/axios_Interceptor/api";

const HomeIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
  </svg>
);

const profileImage = (path?: string) => {
  const image = path?.trim();
  if (!image) return require("../../../Image/Logo.png");
  return /^(https?:|data:|\/)/i.test(image) ? image : SERVER_ADDRESS + "openfile/" + image;
};

const SearchStore = () => {
  const location = useLocation();

  const searchText = location.state?.searchText;
  const searchInput = useRef<HTMLInputElement>(null);

  // 스토어 검색
  const [text, setText] = useState("");
  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
  };

  // 데이터
  const [storeList, setStoreList] = useState<any[]>([]);
  const [searchOn, setSearchOn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const searchRequest = useRef(0);

  const search_live = useCallback(async (storeName: string) => {
    const request = ++searchRequest.current;
    const keyword = storeName.trim();
    setStoreList([]);
    setError("");
    if (!keyword) {
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const token = await restoreSession();
      if (request !== searchRequest.current) return;
      const client = token ? api : api2;
      const res = await client.get(url.Communication_url.store_search, {
        params: {
          store: keyword,
        },
      });

      if (!Array.isArray(res.data)) throw new Error("Invalid store search response");
      if (request === searchRequest.current) setStoreList(res.data);
    } catch (error) {
      console.error(error);
      if (request === searchRequest.current) setError("스토어를 불러오지 못했습니다. 다시 검색해주세요.");
    } finally {
      if (request === searchRequest.current) setLoading(false);
    }
  }, []);

  useEffect(() => () => {
    searchRequest.current++;
  }, []);

  useEffect(() => {
    if (searchText) {
      setText(searchText);
      setSearchOn(true);
      search_live(searchText);
    }
  }, [searchText, search_live]);

  return (
    <Layout_user>
      <SearchPage>
      <SearchContent>
      <TopBar title={"스토어 찾기"} />
      <SearchDiv role="search" aria-label="스토어 검색" onSubmit={(event) => {
        event.preventDefault();
        setSearchOn(Boolean(text.trim()));
        search_live(text);
      }}>
        <SearchIcon aria-hidden="true">
          <img src={require("../../../Image/ic_find_black.png")} alt="" />
        </SearchIcon>
        <SearchInput
          ref={searchInput}
          type="text"
          aria-label="스토어명"
          enterKeyHint="search"
          placeholder="스토어명을 입력해주세요."
          value={text}
          onChange={handleTextChange}
          onKeyDown={(e) => {
            if (e.key === "Enter" && (e.nativeEvent.isComposing || e.keyCode === 229)) {
              e.preventDefault();
            }
          }}
        />
        {text.length > 0 && (
          <SearchButton
            type="button"
            aria-label="검색어 지우기"
            onClick={() => {
              searchRequest.current++;
              setText("");
              setSearchOn(false);
              setStoreList([]);
              setLoading(false);
              setError("");
              searchInput.current?.focus();
            }}
          >
            <img src={require("../../../Image/ic_search_del.png")} alt="" />
          </SearchButton>
        )}
        <SearchSubmitButton type="submit">검색</SearchSubmitButton>
      </SearchDiv>

      {!searchOn && <ContentState icon="search" title="어떤 스토어를 찾으세요?" description="좋아하는 스토어를 검색하고
새로운 라이브를 만나보세요." />}
      {searchOn && (
        <div style={{ padding: "0 16px 24px 16px" }}>
          {loading ? (
            <ContentState kind="loading" icon="search" title="스토어를 검색하고 있습니다." />
          ) : error ? (
            <ContentState kind="error" icon="store" title={error} description="연결 상태를 확인하고 다시 시도해 주세요." action={{ label: "다시 시도", onClick: () => { void search_live(text); } }} />
          ) : <>
          <div
            style={{
              color: "var(--user-text-muted)",
              marginTop: 24,
              marginBottom: 24,
              fontSize: 14,
              fontFamily: "var(--font-Pretendard-Regular)",
            }}
          >
            검색 결과{" "} 총
            <span
              style={{
                color: "var(--user-text)",
                fontFamily: "var(--font-Pretendard-SemiBold)",
              }}
            >
              &nbsp;{storeList.length}개
            </span>
            의 스토어를 찾았습니다.
          </div>

          {storeList.length > 0 ? (
            <StoreListContainer>
              {storeList.map((store) => (
                <StoreItem key={store.store_seq} to={`/store/${store.store_seq}`} aria-label={`${store.store_name} 방문`}>
                  <StoreLeft>
                    <StoreProfileImg
                      src={profileImage(store.profile_img)}
                      alt=""
                      onError={(e) => {
                        (e.target as HTMLImageElement).src = require("../../../Image/Logo.png");
                      }}
                    />
                    <StoreInfoText>
                      <StoreNameText title={store.store_name}>{store.store_name}</StoreNameText>
                      <StoreFollowCount>
                        팔로우 {Number.isInteger(store.follow_count) && store.follow_count >= 0
                          ? store.follow_count.toLocaleString("ko-KR") : "확인 불가"}
                      </StoreFollowCount>
                    </StoreInfoText>
                  </StoreLeft>
                  <VisitBtn aria-hidden="true">
                    <HomeIcon />
                    방문
                  </VisitBtn>
                </StoreItem>
              ))}
            </StoreListContainer>
          ) : (
            <ContentState icon="search" title="검색된 스토어가 없습니다." description="스토어 이름을 확인하거나 다른 이름으로 검색해 보세요." action={{ label: "검색어 수정", onClick: () => searchInput.current?.focus() }} />
          )}
          </>}
        </div>
      )}
      </SearchContent>
      <Footer />
      </SearchPage>
    </Layout_user>
  );
};

export default SearchStore;

const SearchPage = styled.div`
  min-height: var(--browser-layout-height, 100dvh);
  display: flex;
  flex-direction: column;
`;

const SearchContent = styled.main`
  flex: 1 0 auto;
`;

const SearchDiv = styled.form`
  flex-direction: row;
  display: flex;
  background-color: var(--user-surface-raised);
  border-radius: 8px;
  border: 1px solid var(--user-border);
  width: calc(100% - 32px);
  min-height: 50px;
  padding: 2px;
  align-items: center;
  justify-content: flex-start;
  margin: 16px 16px 0;
  box-sizing: border-box;
`;

const SearchButton = styled.button`
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  img { width: 18px; height: 18px; }
  &:hover { background: var(--user-surface-raised); }
  &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: -4px; }
`;

const SearchInput = styled.input`
  min-width: 0;
  flex: 1;
  padding: 0;
  font-family: inherit;
  font-size: 14px;
  color: var(--user-text);
  background-color: transparent;
  border: none;
  outline: none;
  caret-color: var(--user-accent);
  &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 4px; }
  &::placeholder { color: var(--user-text-muted); }
  &::selection { background: #7955f0; }
`;


const StoreListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const StoreItem = styled(Link)`
  text-decoration: none;
  border-radius: 8px;
  &:focus-visible { outline: 2px solid #bfaaff; outline-offset: 5px; }
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-height: 40px;
  gap: 12px;
  width: 100%;
`;

const StoreLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1;
`;

const StoreProfileImg = styled.img`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 50%;
  object-fit: cover;
`;

const StoreInfoText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

const StoreNameText = styled.div`
  color: var(--user-text);
  font-size: 14px;
  line-height: 18px;
  font-family: var(--font-Pretendard-SemiBold);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StoreFollowCount = styled.div`
  color: var(--user-text-muted);
  font-size: 12px;
  line-height: 16px;
  font-family: var(--font-Pretendard-Regular);
`;

const VisitBtn = styled.span`
  background: linear-gradient(135deg, #7955f0, #3209b9);
  color: white;
  font-size: 14px;
  font-family: var(--font-Pretendard-SemiBold);
  width: 80px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  &:hover { filter: brightness(1.12); }
  &:focus-visible { outline: 2px solid white; outline-offset: 3px; }
  &:active {
    transform: scale(0.95);
  }
`;

const SearchIcon = styled.span`
  img { filter: var(--user-icon-filter); }
  display: grid; place-items: center; flex-shrink: 0; width: 40px;
  img { width: 18px; height: 18px; }
`;
